import React from 'react';
import { FormattedMessage } from 'react-intl';
import TwoPeopleTalking from '../../../../assets/images/header_image.jpg';
import Heading from '../../../../common/Heading';
import s from './Intro.module.scss';

function IntroPicture() {
  return (
    <header className={s.intro}>
      <div className={s.imageWrapper}>
        <img className={s.introImage} src={TwoPeopleTalking} alt="" />
      </div>
      <div className={`container ${s.headingAndP}`}>
        <Heading level={2} htmlLevel={1}>
          <span>
            <FormattedMessage id="contactpage.intro.title.line1" />
          </span>
          <span>
            <FormattedMessage id="contactpage.intro.title.line2" />
          </span>
        </Heading>
      </div>
    </header>
  );
}

export default IntroPicture;
